<div class="dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <h2>Category vs. Outcome </h2>
      <!-- <button mat-stroked-button color="accent" (click)="downloadCSV()">
        <mat-icon>download</mat-icon> Export CSV
      </button> -->
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="sp" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="sp"></mat-datepicker-toggle>
      <mat-datepicker #sp></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="ep" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="ep"></mat-datepicker-toggle>
      <mat-datepicker #ep></mat-datepicker>
    </mat-form-field>

    <!-- <button mat-raised-button color="primary" (click)="fetchCrossTab()">
      Update View
    </button> -->
     <div class="filter-actions" style="display: flex; gap: 8px;">
      <button mat-raised-button color="primary" (click)="fetchCrossTab()">
        Update
      </button>
      <button mat-stroked-button color="accent" (click)="downloadCSV()" >
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>
  </div>

  <div class="content-grid" style="display: flex; flex-direction: column; gap: 2rem;">
    <mat-card class="chart-card">
      <mat-card-content style="height: 500px; padding: 20px;">
        <canvas baseChart
          [data]="stackedBarData"
          [options]="stackedBarOptions"
          [type]="'bar'">
        </canvas>
      </mat-card-content>
    </mat-card>

    <table mat-table [dataSource]="crossTabData" class="mat-elevation-z8 styled-table">
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef> Conversation Category </th>
        <td mat-cell *matCellDef="let row"> {{row.conversation_category}} </td>
      </ng-container>

      <ng-container matColumnDef="satisfied">
        <th mat-header-cell *matHeaderCellDef> Satisfied </th>
        <td mat-cell *matCellDef="let row"> {{row.Satisfied}} </td>
      </ng-container>

      <ng-container matColumnDef="indifferent">
        <th mat-header-cell *matHeaderCellDef> Indifferent </th>
        <td mat-cell *matCellDef="let row"> {{row.Indifferent}} </td>
      </ng-container>

      <ng-container matColumnDef="not_satisfied">
        <th mat-header-cell *matHeaderCellDef> Not Satisfied </th>
        <td mat-cell *matCellDef="let row"> {{row.Not_Satisfied}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['category', 'satisfied', 'indifferent', 'not_satisfied']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['category', 'satisfied', 'indifferent', 'not_satisfied'];"></tr>
    </table>
  </div>
</div>